export default __webpack_public_path__ + "static/media/gif-selfie.abfc0a62.gif";